import { inject } from '@angular/core';
import * as fromScreen from '@app/root-store/ui/screen';
import { Store } from '@ngrx/store';

export const onlyDesktopActivate = () => {
  const store = inject(Store);
  store.dispatch(fromScreen.setDesktopOnlyViewActive({desktopOnly: true}))
  return true;
}